import { useEffect } from 'react';
import styles from './App.module.scss';
import { Slide, ToastContainer } from 'react-toastify';
import { inject, observer } from 'mobx-react';
import ConnectRouter from './router/ConnectRouter';
import routes from './router/routes';
import { RootStore } from './store';
import { ErrorBoundary } from './pages/ErrorBoundary';
import { Cmp } from '@enterprise/common';
import { useAuth0 } from '@auth0/auth0-react';

interface IAppProps {
    rootStore?: RootStore;
}

const App = inject('rootStore')(
    observer(function App({ rootStore: _rootStore }: IAppProps) {
        const rootStore = _rootStore as RootStore;
        const auth0 = useAuth0();

        useEffect(() => {
            rootStore.app.setAuthClient(auth0);
        }, [auth0, auth0.isLoading, auth0.isAuthenticated, rootStore]);

        useEffect(() => {
            rootStore.bootstrap();
        }, []);

        const { isLoaded } = rootStore;

        return (
            <div className={styles.enterpriseApp}>
                <Cmp.If cond={isLoaded}>
                    <ErrorBoundary>
                        <ConnectRouter routes={routes} />
                    </ErrorBoundary>
                </Cmp.If>
                <Cmp.If cond={!isLoaded}>Loading...</Cmp.If>
                <ToastContainer
                    position="top-center"
                    autoClose={10000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick={true}
                    rtl={false}
                    draggable={true}
                    pauseOnHover={true}
                    theme="colored"
                    transition={Slide}
                />
            </div>
        );
    }),
);

export default App;
